import { Loader2, CheckCircle2, XCircle, Ban } from "lucide-react";

interface SeedBrandCandidate {
  id: number;
  brandName: string;
  scanStatus: string;
  adsScraped: number | null;
  scanError: string | null;
  approved: boolean;
}

interface SeedJobAd {
  id: number;
  seedCandidateId?: number;
  analysisStatus: string;
}

export function SeederScanningProgress({
  candidates,
  ads,
}: {
  candidates: SeedBrandCandidate[];
  ads: SeedJobAd[];
}) {
  const approved = candidates.filter((c) => c.approved);

  return (
    <div>
      <h3 className="text-sm font-semibold mb-4">Scanning approved brands…</h3>
      <div className="space-y-2">
        {approved.map((c) => {
          const analyzed = ads.filter((a: any) => a.seedCandidateId === c.id && a.analysisStatus === "complete").length;
          const total = c.adsScraped ?? 0;
          return (
            <div
              key={c.id}
              data-testid={`row-scan-${c.id}`}
              className="flex items-center gap-3 p-2 border border-[#DCE3ED] rounded"
            >
              {c.scanStatus === "completed" ? (
                <CheckCircle2 className="h-4 w-4 text-green-600 flex-shrink-0" />
              ) : c.scanStatus === "failed" ? (
                <XCircle className="h-4 w-4 text-red-600 flex-shrink-0" />
              ) : c.scanStatus === "skipped" ? (
                <Ban className="h-4 w-4 text-[#526074] flex-shrink-0" />
              ) : (
                <Loader2 className="h-4 w-4 animate-spin text-blue-500 flex-shrink-0" />
              )}
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium truncate">{c.brandName}</div>
                {c.scanStatus === "scanning" && (
                  <div className="text-xs text-[#526074]">Fetching ads from Meta…</div>
                )}
                {c.scanStatus === "completed" && (
                  <div className="text-xs text-[#526074]">
                    {total} ad{total === 1 ? "" : "s"} scraped · {analyzed}/{total} analyzed
                  </div>
                )}
                {c.scanStatus === "skipped" && (
                  <div className="text-xs text-[#526074]">Skipped: {c.scanError}</div>
                )}
                {c.scanStatus === "failed" && (
                  <div className="text-xs text-red-600">Failed: {c.scanError}</div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
